import MuiDivider from "@mui/material/Divider";
const Divider = MuiDivider;
export default Divider;
